module.exports = __webpack_public_path__ + "static/media/icon_contact-support.333a1bca.svg";